import { Task, TaskDefinition, } from "multitool-sdk-core";
export class BrowserInlineTaskDefinition extends TaskDefinition {
    handler;
    constructor(opts) {
        super(opts);
        this.handler = opts.handler;
    }
    async run(task) {
        console.log("Running inline", task);
        await this.handler(task);
    }
}
//# sourceMappingURL=BrowserInlineTaskDefinition.js.map